import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

class LoadMasteryTestItemService {
  fetch = new FetchService();
  constructor() {
    extendObservable(this, {
      masteryTestItem: null,
    });
  }

  handleLoad = action((moduleId, masteryTestId, itemId) => {
    Promise.all([
      this.fetch.fetch({
        url: `/mastery-tests/${masteryTestId}/items/${itemId}`,
      }),
      this.fetch.fetch({
        url: `/modules/${moduleId}/mastery-tests/${masteryTestId}`,
      }),
      this.fetch.fetch({
        url: `/modules/${moduleId}`,
      }),
    ]).then(([{ item, order }, masteryTest, module]) => {
      this.masteryTestItem = {
        order,
        item,
        masteryTest: { ...masteryTest, module },
      };
    });
  });
}

export default LoadMasteryTestItemService;
